export function selectSidebarTab(selectedSidebarTab: string): BaseTockAction {
  return {
    type: 'UI_SELECT_SIDEBAR_TAB',
    payload: selectedSidebarTab,
  };
}
